var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._b({staticClass:"font-weight-600 align-center",staticStyle:{"border-radius":"10px","padding":"4px 8px","white-space":"nowrap","display":"inline-block"},style:({
    background: _vm.bgColor,
    color: _vm.textColor,
  })},'span',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.formattedValue)+" "),(_vm.addOnText)?_c('span',{staticClass:"font-size-12 font-weight-400 ml-1",staticStyle:{"border-radius":"10px","padding":"2px 4px","background-color":"#d2ebd2"}},[_vm._v(" "+_vm._s(_vm.addOnText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }